/**
 * Czy gracz ma strój kąpielowy (suit) — wymagany do wody / wyścigu (§11, §14.5).
 * Cap opcjonalny. Czysta funkcja pod unit-testy.
 */
export type SwimOutfitLike = {
  suit?: string | null;
  cap?: string | null;
};

export function hasSwimOutfit(
  swim: SwimOutfitLike | Record<string, string | null> | null | undefined,
): boolean {
  if (!swim) return false;
  const suit = 'suit' in swim ? swim.suit : null;
  return typeof suit === 'string' && suit.trim().length > 0;
}
